export const doFetch = async (url: string, options: any) => {
  try {
    const fetchRes = await window.fetch(url, options);
    let { statusText } = fetchRes;
    const { status } = fetchRes;

    if (status >= 400) {
      const error = {
        status,
        message: statusText,
      };
      const msg = await fetchRes.json();
      if (msg && msg.message) {
        statusText = msg.message;
        error.message = statusText;
      }
      throw error;
    }

    const result = await fetchRes.json();
    return result;

  } catch (e) {
    throw e;
  }
}